import { Children, cloneElement, isValidElement, useState } from 'react'

type Props = {
  children: React.ReactNode
  className?: string
  vertical?: boolean
  activeKey?: string
  onChildClone?: (child: React.ReactElement) => React.ReactElement
  onChange?: (value: string) => void
}

export const Tabs = ({
  children,
  className,
  vertical = false,
  activeKey,
  onChange,
}: Props) => {
  const [valueKey, setValueKey] = useState(activeKey)

  return (
    <div className={className}>
      <ul
        className={`flex flex-wrap ${
          vertical ? 'flex-col space-y-3' : 'items-center space-x-2'
        }`}
      >
        {Children.map(
          children,
          child =>
            isValidElement(child) &&
            cloneElement(child, {
              active: valueKey && valueKey === child.props.valueKey,
              onChange: (value: string) => {
                if (!value) return
                setValueKey(value)
                onChange && onChange(value)
              },
            } as any)
        )}
      </ul>
    </div>
  )
}
